/* 
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEvent} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {dlsColor} from '../../theme/theme';
import {DLSTheme} from '../../types/types';

export interface CardLabelType {
  color?: string;
  labelText: string;
  textColor?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}

const useStyles = makeStyles((theme: DLSTheme) => ({
  cardLabel : {
    backgroundColor : ({color}: {color: string}) => color,
    width           : 'fit-content',
    padding         : '4px',
    borderRadius    : '3px',
    letterSpacing   : '1px',
    whiteSpace      : 'nowrap',
    overflow        : 'hidden',
    textOverflow    : 'ellipsis',
    color           : ({textColor}: {textColor: string}) => textColor || dlsColor('white'),
    ...theme.dls?.typography?.tags
  }
}));

export const CardLabel = ({
  color = dlsColor('grey5'),
  labelText,
  onClick,
  textColor
}: CardLabelType) => {
  const classes = useStyles({color, textColor});
  return (
    <div className={classes.cardLabel} onClick={onClick}>
      {labelText}
    </div>
  );
};

export default CardLabel;
